// extracted by mini-css-extract-plugin
export default {"wrapper":"ECS_9sZ5sLlK5Dt","tablet":"RNShj5PQcbihEk_","fixed":"zp2AUxmWACM6nQl"};